module.exports = __webpack_public_path__ + "static/media/lineto-circular-pro-bold.2c34e4ea.ttf";